import React, { Component } from 'react';
import {UISref,UISrefActive} from 'ui-router-react'; 

class SubmenuDiscussion extends Component {
	render(){
		const {title}  = this.props;
		return(
			<div className="submenu-section-wrapper">
				<ul role="menu" aria-label="Sub Navigation" className="submenu-section">
					<UISrefActive  class="active">
						<UISref to="root.diskussionen">
							<li id="submenu-diskussionen" role="menuitem" ><a>{title.rendered}</a></li> 
						</UISref>	
					</UISrefActive>
				</ul>
			</div>
		)
	}	
}
export default SubmenuDiscussion;


// WEBPACK FOOTER //
// ./src/components/SubmenuDiscussion.js